/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { Animated } from 'react-native';

export const DESKTOP_CARD_SCALE = 0.96;

export const animateDesktopArticleCardScale = ({
  scale,
  toValue,
}: {
  scale: Animated.Value;
  toValue: number;
}) => {
  Animated.spring(scale, {
    toValue,
    useNativeDriver: true,
    speed: 22,
    bounciness: 5,
  }).start();
};
